var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ReactComponent as TimeIconSVG } from '../../assets/images/global/hpms-time.svg';
import { ReactComponent as CheckGrayIconSVG } from '../../assets/images/global/check-blue.svg';
import { ReactComponent as CheckIconSVG } from '../../assets/images/global/check-green.svg';
import './card-exams-information.css';
let CardExamsInformation = class CardExamsInformation extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        onClick
                    }
                }));
            }
        };
    }
    getSvg() {
        const { status } = this.props;
        if (status == 'A') {
            return React.createElement(CheckIconSVG, { className: 'status-icon' });
        }
        if (status == 'P') {
            return React.createElement(TimeIconSVG, { className: 'status-icon' });
        }
        if (status == 'R') {
            return React.createElement(CheckGrayIconSVG, { className: 'status-icon' });
        }
        return React.createElement(React.Fragment, null);
    }
    getExpression() {
        const { status } = this.props;
        if (status == 'A') {
            return MessageService.translate('result.available');
        }
        if (status == 'P') {
            return MessageService.translate('result.processing');
        }
        if (status == 'R') {
            return MessageService.translate('result.ready');
        }
        return '';
    }
    render() {
        return (React.createElement(Card, { onClick: () => this.onClick(), width: 12, className: 'card-exam-information', selectionType: SelectionType.SINGLE, uuid: "cc12ce28-962b-4bd0-9d7c-22ddf6707e3c" },
            this.renderDateInfo(),
            this.renderStatusInfo()));
    }
    renderStatusInfo() {
        return (React.createElement("div", { className: 'status-info' },
            React.createElement("div", { className: 'info-label' }, MessageService.translate('result.exam-status')),
            React.createElement("div", { className: 'status' },
                this.getSvg(),
                this.getExpression())));
    }
    renderDateInfo() {
        const { dtProcedimento } = this.props;
        const weekDay = dtProcedimento ? ModelService.format('date', dtProcedimento) : '';
        return (React.createElement("div", { className: 'date-info' },
            React.createElement("div", { className: 'info-label' }, MessageService.translate('result.date')),
            React.createElement("div", { className: 'day-week' }, weekDay)));
    }
};
CardExamsInformation.propTypes = {
    onClick: eventListener,
    dtProcedimento: string,
    status: string,
};
CardExamsInformation = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardExamsInformation);
export default CardExamsInformation;
//# sourceMappingURL=card-exams-information.js.map